<template>
  <div>
	  <div class="logostyle">
	    <el-row>
	      <el-col :span="24">
	        <img src="/static/img/logo.png" style="height:166px;width:130px;"></img>
	      </el-col>
	    </el-row>
	  </div>
	  <div class="loginConter" v-loading="loading">
	    <el-form class="login" :model="user" label-width="80px" :rules="rules" ref="login">
	  	  <h3 class="title">登录</h3>
	  	  <el-form-item label="手机号" prop="phone">
	  	    <el-input v-model="user.phone">
	  	      <i class="iconfont icon-user" slot="prepend"></i>
	  	    </el-input>
	  	  </el-form-item>
	  	  <el-form-item label="密码" prop="password">
	        <el-input type="password" v-model="user.password" @keyup.enter.native="login">
	          <i class="iconfont icon-iconfontlock" slot="prepend"></i>
	        </el-input>
	      </el-form-item>
	      <el-form-item>
	        <el-button type="primary" @click="login" class="loginBtn">登录</el-button>
	      </el-form-item>
	    </el-form>
	  </div>
	  <div class="logostyle">
	    <el-row>
	      <el-col :span="24">

	      </el-col>
	    </el-row>
	  </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      user: {
        phone: '',
        password: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    notifyErr (msg) {
      this.$notify.error({
        title: '错误',
        message: msg,
        offset: 100
      })
    },
    login () {
      console.log('login...')
      this.$refs.login.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('Login', this.user).then(() => {
            this.loading = false
            this.$router.push({name: 'welcome'})
          }).catch(err => {
            console.log(err)
            this.loading = false
            this.notifyErr(err)
          })
        } else {
          console.log('error submit!!')
          this.notifyErr('请输入正确的用户名密码')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
  .title {
    font-size: 26px;
    font-weight: 400;
    margin: 0px auto 20px auto;
    text-align: center;
    font-weight: bold;
  }
  .loginConter{
    width: 100%;
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #324057;
  }
  .logostyle{
    width: 100%;
    min-height: calc((100vh - 200px)/2);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #324057;
  }
  .login{
    width: 30%;
    min-width: 200px;
    box-shadow: 0 0 10px black;
    padding: 20px 20px 0 20px;
    border-radius: 5px;
    background-color: white;
  }
  .loginBtn{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// login.vue?b222ecce